import React, { useState } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import axios from 'axios';
import { LOG_IN } from './queries';
import { reactQueryConfig, getLocalStorageValues } from '../../constants/index';
import { navLinks } from 'utils/nav-links-util';
import { SignIn as SignInComponent } from '@sidraaabdullah/test-shared-library';
import { H4, H6, P } from 'components/reusable-css';
import { languageArray } from 'constants/language';

const SignIn = ({ queryClient }) => {
  const { t, i18n } = useTranslation();
  let { userName: UserName } = getLocalStorageValues();
  let history = useHistory();
  const obj = localStorage.getItem('remember');
  let email = '';

  if (obj) {
    const { email: e } = JSON.parse(obj);
    email = e;
  }
  let defaultLang = i18n.language === 'en-US' ? 'en' : i18n.language;
  const [language, setLanguage] = useState(defaultLang);
  const [userName, setUserName] = useState(email);
  const [password, setPassword] = useState('');
  const [trigger, setTrigger] = useState(false);
  const [open, setOpen] = useState(false);
  const [loginResult, setLoginResult] = useState('signin.string7');
  const [severity, setSeverity] = useState('');
  const [isRememberPassword, setIsRememberPassword] = useState(email && true);
  const { isLoading: loginIsLoading } = useQuery(['LOG_IN', { userName: userName, password: btoa(password) }], LOG_IN, {
    enabled: trigger,
    ...reactQueryConfig,
    onSuccess: async (res) => {
      if (queryClient) queryClient.clear();
      axios.defaults.headers.common.Authorization = `Bearer ${res.token}`;
      localStorage.setItem(
        'userName',
        JSON.stringify({
          userName: res.username,
          email: userName,
          token: res.token,
        }),
      );
      if (isRememberPassword) {
        localStorage.setItem(
          'remember',
          JSON.stringify({
            email: userName,
          }),
        );
      } else {
        localStorage.removeItem('remember');
      }

      setTrigger(false);
      history.replace(navLinks.home.link);
    },
    onError: () => {
      setSeverity('error');
      setLoginResult('signin.string8');
      setOpen(true);
      setTrigger(false);
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setTrigger(true);
  };

  const handleLanguage = (value) => {
    setLanguage(value);
    i18n.changeLanguage(value);
  };

  if (UserName?.token) {
    return <Redirect from="*" to={navLinks.home.link} />;
  }
  return (
    <SignInComponent
      loginResult={t(loginResult)}
      severity={severity}
      handleSubmit={handleSubmit}
      isLoginLoading={loginIsLoading || trigger}
      isAlertOpen={ open}
      handleAlert={(e) => setOpen(e)}
      userName={userName}
      handleUserName={(e) => setUserName(e)}
      password={password}
      handlePassword={(e) => setPassword(e)}
      isRememberPassword={isRememberPassword}
      setIsRememberPassword={(e) => setIsRememberPassword(e)}
      language={language}
      handleLanguage={(value) => handleLanguage(value)}
      is_admin={true}
      Heading4={H4}
      Paragraph={P}
      Heading6={H6}
      languageArray={languageArray}
      signin={{
        headerText: t('signin.string1'),
        inputText1: t('signin.string2'),
        inputText2: t('signin.string3'),
        checkboxText: t('signin.string4'),
        buttonText: t('signin.string6'),
      }}
    />
  );
};

export default SignIn;
